import {

    GoogleMap,

    Marker,

    useJsApiLoader,

} from "@react-google-maps/api";

import {

    useEffect,

    useState,

} from "react";

import {

    useParams,

} from "react-router-dom";

import socket from "../../../services/socket";

import API from "../../../services/api";

import "./LiveTracking.css";

function LiveTracking() {

    const { orderId } = useParams();

    const [order, setOrder] = useState(null);

    const [deliveryLocation, setDeliveryLocation] = useState(null);

    const {

        isLoaded,

    } = useJsApiLoader({

        googleMapsApiKey:

            import.meta.env.VITE_GOOGLE_MAPS_KEY,

    });
    useEffect(() => {

    loadOrder();

}, []);

const loadOrder = async () => {

    const res = await API.get(

        `/orders/${orderId}`

    );

    setOrder(res.data.order);

};
useEffect(() => {

    socket.on(

        "delivery-location-updated",

        (data) => {

            if (

                data.orderId === orderId

            ) {

                setDeliveryLocation({

                    lat: data.latitude,

                    lng: data.longitude,

                });

            }

        }

    );

    return () => {

        socket.off(

            "delivery-location-updated"

        );

    };

}, []);
if (

    !isLoaded ||

    !order

)

return null;

return (

<GoogleMap

    zoom={16}

    center={

        deliveryLocation ||

        {

            lat:Number(

                order.addressSnapshot.latitude

            ),

            lng:Number(

                order.addressSnapshot.longitude

            ),

        }

    }

    mapContainerClassName="tracking-map"

>

    {/* Customer */}

    <Marker

        position={{

            lat:Number(

                order.addressSnapshot.latitude

            ),

            lng:Number(

                order.addressSnapshot.longitude

            ),

        }}

    />

    {/* Delivery Partner */}

    {

        deliveryLocation && (

            <Marker

                position={

                    deliveryLocation

                }

            />

        )

    }

</GoogleMap>

);

}

export default LiveTracking;